import * as React from 'react';

import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import { useTypedTranslation } from 'shared/entities/localization';
import { IconSize } from 'shared/entities/components/Icon';

import Accounts from './Accounts';

import './SocialNetworks.modules.scss';

type Props = {
  className?: string;
  title?: React.ReactNode;
};

const SocialNetworks: React.FC<Props> = ({ className, title }) => {
  const { t } = useTypedTranslation('newComponents');

  return (
    <div styleName="social-networks" className={className}>
      <Typography
        fontType={TypographyType.text}
        fontWeight={TypographyWeight.heavy}
        fontSize={TypographySize.s}
        fontColor={TypographyColor.main}
        styleName="social-networks__content"
      >
        {title ?? t('SocialNetworks.title')}
      </Typography>
      <Accounts size={IconSize.L} />
    </div>
  );
};

export default React.memo(SocialNetworks);
